var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { PageLoaderContainer } from './styles';
var PageLoader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'lg' : _b, _c = _a.color, color = _c === void 0 ? '#858585' : _c, _d = _a.height, height = _d === void 0 ? 40 : _d, _e = _a.style, style = _e === void 0 ? {} : _e;
    return (_jsx(PageLoaderContainer, __assign({ style: style }, { children: _jsx(FontAwesomeIcon, { color: color, size: size, height: height, icon: faSpinner, spin: true }) })));
};
export default PageLoader;
